import {
  Card,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";

import { ToothSample,initProvince, Province,City, initCity,
  County, initCounty,Hospital, initHospital,initSchool, School,
  Grade, initGrade,Class, initClass } from "../../../models";
import { getTable, getTableAll, newStudentCode } from "../../../api/Api";
import { useHistory } from "react-router-dom";
interface PropsType {
  editRecord: ToothSample;
  setAge: Function;
}
export const SchoolPerson: React.FC<PropsType> = ({ editRecord, setAge }) => {
  const [provinceOptions, setProvinceOptions] = useState<any[]>([]);
  const [cityOptions, setCityOptions] = useState<any[]>([]);
  const [countyOptions, setCountyOptions] = useState<any[]>([]);
  const [hospitalOptions, setHospitalOptions] = useState<any[]>([]);
  const [schoolOptions, setSchoolOptions] = useState<any[]>([]);
  const [gradeOptions, setGradeOptions] = useState<any[]>([]);
  const [classOptions, setClassOptions] = useState<any[]>([]);

  const [province, setProvince] = useState(initProvince);
  const [city, setCity] = useState(initCity);
  const [county, setCounty] = useState(initCounty);
  const [hospital, setHospital] = useState(initHospital);
  const [school, setSchool] = useState(initSchool);
  const [grade, setGrade] = useState(initGrade);
  const [class1, setClass1] = useState(initClass);

  const [code, setCode] = useState("");
  const [form] = Form.useForm();
  const history = useHistory();
  useEffect(() => {
    getProvinceOptions();
    initData();
  }, [editRecord, form]);
  const initData = async () => {
    let h: Hospital = initHospital;
    let p: Province = initProvince;
    let city: City = initCity;
    let county: County = initCounty;

    if (editRecord.id !== -1) {
      if (editRecord.hospitalId !== -1) {
        h = await getTable("hospital", editRecord.hospitalId);
        p = await getTable("province", h.provinceId);
        city = await getTable("city", h.cityId);
        county = await getTable("county", h.countyId);
        if(typeof h === "undefined" || typeof p === "undefined" || typeof city === "undefined" || typeof county === "undefined"){
          history.push("/");      
        }
        setHospital(h);
        setProvince(p);
        setCity(city);
        setCounty(county);
      }
      if (editRecord.schoolId !== -1) {
        let s: School = await getTable("school", editRecord.schoolId);
        if(typeof s === "undefined"){
          history.push("/");      
        }
        setSchool(s);
      }
      if (editRecord.gradeId !== -1) {
        let g: Grade = await getTable("grade", editRecord.gradeId);
        if(typeof g === "undefined"){
          history.push("/");      
        }
        setGrade(g);
      }
      if (editRecord.classId !== -1) {
        let c: Class = await getTable("class", editRecord.classId);
        if(typeof c === "undefined"){
          history.push("/");      
        }
        setClass1(c);
      }
    }
    if (editRecord.id !== -1) {
      form.setFieldsValue({
        sex: editRecord.sex,
        name: editRecord.name,
        age: editRecord.age,
        ageMonth:editRecord.ageMonth,
        code: editRecord.code,
        hospital: editRecord.hospitalName,
        school: editRecord.schoolName,
        grade: editRecord.gradeName,
        class: editRecord.className,
        province: p.name,
        city: city.name,
        county: county.name,
        phoneNo:editRecord.phoneNo,
        sender:editRecord.sender,
        checker:editRecord.checker,
      });
      setCode(editRecord.code);
    } else {
      setCode("");
      form.setFieldsValue({
        sex: undefined,
        name: "",
        age: undefined,
        ageMonth:0,
        code: "",
        province: undefined,
        city: undefined,
        county: undefined,
        hospital: undefined,
        school: undefined,
        grade: undefined,
        class: undefined,
        phoneNo:undefined,
        sender:undefined,
        checker:undefined,
      });
    }
  };
  const onItemChange = (e: any) => {
    editRecord.sex = form.getFieldValue("sex");
    editRecord.name = form.getFieldValue("name");
    editRecord.phoneNo = form.getFieldValue("phoneNo");
    editRecord.sender = form.getFieldValue("sender");
    editRecord.checker = form.getFieldValue("checker");
  };
  const getProvinceOptions = async () => {
    let items: any[] = [];
    let ps: Province[] = await getTableAll("province");
    if(typeof ps === "undefined"){
      history.push("/");      
    }
    ps.forEach((d) => {
      items.push(
        <Select.Option key={d.id} value={d.id}>
          {d.name}
        </Select.Option>
      );
    });
    setProvinceOptions(items);
  };

  const getCityOptions = async (p: Province) => {
    let items: any[] = [];
    let cs: City[] = await getTableAll("city");
    if(typeof cs === "undefined"){
      history.push("/");      
    }
    cs.forEach((d) => {
      if (d.provinceId === p.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.name}
          </Select.Option>
        );
    });
    setCityOptions(items);
  };
  const getCountyOptions = async (c: City) => {
    let items: any[] = [];
    let cs: County[] = await getTableAll("county");
    if(typeof cs === "undefined"){
      history.push("/");      
    }
    cs.forEach((d) => {
      if (d.cityId === c.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.name}
          </Select.Option>
        );
    });
    setCountyOptions(items);
  };

  const getHospitalOptions = async (c: County) => {
    let items: any[] = [];
    let hs: Hospital[] = await getTableAll("hospital");
    if(typeof hs === "undefined"){
      history.push("/");      
    }
    hs.forEach((d) => {
      if (d.countyId === c.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.hospitalName}
          </Select.Option>
        );
    });
    setHospitalOptions(items);
  };

  const getSchoolOptions = async (h: Hospital) => {
    let items: any[] = [];
    let hs: School[] = await getTableAll("school");
    if(typeof hs === "undefined"){
      history.push("/");      
    }
    hs.forEach((d) => {
      if (d.hospitalId === h.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.schoolName}
          </Select.Option>
        );
    });
    setSchoolOptions(items);
  };

  const getGradeOptions = async (s: School) => {
    let items: any[] = [];
    let hs: Grade[] = await getTableAll("grade");
    if(typeof hs === "undefined"){
      history.push("/");      
    }
    hs.forEach((d) => {
      if (d.schoolId === s.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.gradeName}
          </Select.Option>
        );
    });
    setGradeOptions(items);
  };

  const getClassOptions = async (g: Grade) => {
    let items: any[] = [];
    let hs: Class[] = await getTableAll("class");
    if(typeof hs === "undefined"){
      history.push("/");      
    }
    hs.forEach((d) => {
      if (d.gradeId === g.id)
        items.push(
          <Select.Option key={d.id} value={d.id}>
            {d.className}
          </Select.Option>
        );
    });
    setClassOptions(items);
  };

  const onProvinceChange = async (e: any) => {
    let p: Province = await getTable("province", e);
    if(typeof p === "undefined"){
      history.push("/");      
    }
    setProvince(p);
    getCityOptions(p);
    setCountyOptions([]);
    setHospitalOptions([]);
    setSchoolOptions([]);
    setGradeOptions([]);
    setClassOptions([]);
    setCity(initCity);
    setCounty(initCounty);
    setHospital(initHospital);
    setSchool(initSchool);
    setGrade(initGrade);
    setClass1(initClass);
  };

  const onCityChange = async (e: any) => {
    let c: City = await getTable("city", e);
    if(typeof c === "undefined"){
      history.push("/");      
    }
    setCity(c);
    getCountyOptions(c);
    setHospitalOptions([]);
    setSchoolOptions([]);
    setGradeOptions([]);
    setClassOptions([]);
    setCounty(initCounty);
    setHospital(initHospital);
    setSchool(initSchool);
    setGrade(initGrade);
    setClass1(initClass);
  };

  const onCountyChange = async (e: any) => {
    let c: County = await getTable("county", e);
    if(typeof c === "undefined"){
      history.push("/");      
    }
    setCounty(c);
    getHospitalOptions(c);
    setSchoolOptions([]);
    setGradeOptions([]);
    setClassOptions([]);
    setHospital(initHospital);
    setSchool(initSchool);
    setGrade(initGrade);
    setClass1(initClass);
  };

  const onHospitalChange = async (e: any) => {
    let h: Hospital = await getTable("hospital", e);
    if(typeof h === "undefined"){
      history.push("/");      
    }
    setHospital(h);
    getSchoolOptions(h);
    setGradeOptions([]);
    setClassOptions([]);
    setSchool(initSchool);
    setGrade(initGrade);
    setClass1(initClass);
    editRecord.hospitalId = h.id;
    editRecord.hospitalName = h.hospitalName;
  };

  const onSchoolChange = async (e: any) => {
    let s: School = await getTable("school", e);
    if(typeof s === "undefined"){
      history.push("/");      
    }
    setSchool(s);
    getGradeOptions(s);
    setClassOptions([]);
    setGrade(initGrade);
    setClass1(initClass);
    editRecord.schoolId = s.id;
    editRecord.schoolName = s.schoolName;
  };

  const onGradeChange = async (e: any) => {
    let g: Grade = await getTable("grade", e);
    if(typeof g === "undefined"){
      history.push("/");      
    }
    setGrade(g);
    getClassOptions(g);
    setClass1(initClass);
    editRecord.gradeId = g.id;
    editRecord.gradeName = g.gradeName;
  };

  const onClassChange = async (e: any) => {
    let c: Class = await getTable("class", e);
    if(typeof c === "undefined"){
      history.push("/");      
    }
    setClass1(c);
    let code = await newStudentCode(e);
    if(typeof code === "undefined"){
      history.push("/");      
    }
    setCode(code);
    editRecord.classId = c.id;
    editRecord.className = c.className;
    editRecord.code = code;
  };

  const onAgeChange = (e) => {
    let age1 = parseInt(e.target.value);
    setAge(age1);
    editRecord.age = age1;
  };
  const onAgeMonthChange = (e) => {
    editRecord.ageMonth = parseInt(e.target.value);
  };
  const onCodeChange = (e) => {
    setCode(e.target.value);
    editRecord.code = e.target.value;
  };
  return (
    <Card title="受检人信息" style={{ background: "#ececec", margin: "10px" }}>
      <Form
        layout="horizontal"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        form={form}
      >
        <Row>
          <Col span={12}>
            <Form.Item name="province" label="所在省份">
              <Select
                value={province.name}
                onChange={onProvinceChange}
                placeholder="请选择..."
              >
                {provinceOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="school" label="学校/幼儿园">
              <Select
                value={school.schoolName}
                onChange={onSchoolChange}
                placeholder="请选择..."
              >
                {schoolOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="city" label="所在市、区">
              <Select
                value={city.name}
                onChange={onCityChange}
                placeholder="请选择..."
              >
                {cityOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="grade" label="所在年级">
              <Select
                value={grade.gradeName}
                onChange={onGradeChange}
                placeholder="请选择..."
              >
                {gradeOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="county" label="所在县、区">
              <Select
                value={county.name}
                onChange={onCountyChange}
                placeholder="请选择..."
              >
                {countyOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="class" label="所在班级">
              <Select
                value={class1.className}
                onChange={onClassChange}
                placeholder="请选择..."
              >
                {classOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="hospital" label="检测医院">
              <Select
                value={hospital.hospitalName}
                onChange={onHospitalChange}
                placeholder="请选择..."
              >
                {hospitalOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="name" label="姓名">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="sex" label="性别">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"男"}>男</Radio>
                <Radio value={"女"}>女</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="age" label="年龄(岁)">
              <Input onChange={onAgeChange} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="ageMonth" label="年龄(月)">
              <Input onChange={onAgeMonthChange} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="code" label="编号">
              <Tooltip title="学生编号规则：5位学校编号 + 1位年级编号 + 1位班级编号 + 3位学生编号">
                <Input value={code} onChange={onCodeChange} />
              </Tooltip>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="checker" label="检测医生">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>      
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item name="phoneNo" label="电话号码">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>        
          <Col span={12}>
            <Form.Item name="sender" label="送检者">
              <Input onChange={onItemChange} />
            </Form.Item>
          </Col>
        </Row>        
      </Form>
    </Card>
  );
};
